// extracted by mini-css-extract-plugin
export default {"Scroll":"ScrollLTR_Scroll__0ZkUb","RTL":"ScrollLTR_RTL__r3wrE"};